import { Outlet } from "react-router-dom";
import { Box, Container, Paper, Typography } from "@mui/material";

export function AuthLayout() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0F3D63",
        backgroundImage: "linear-gradient(135deg, #0F3D63 0%, #1976D2 100%)",
      }}
    >
      <Container maxWidth="xs">
        <Paper elevation={6} sx={{ p: 4, borderRadius: 3 }}>
          <Typography variant="h4" fontWeight={700} color="#0F3D63" gutterBottom textAlign="center">
            TekInvest
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center" mb={3}>
            TekStar Technologies Pvt. Ltd.
          </Typography>
          <Outlet />
        </Paper>
      </Container>
    </Box>
  );
}

export default AuthLayout;
